import { Route, Routes } from '@angular/router';
import { permissionGuard } from 'src/lib/guards/permission.guard';
import { CALCULATION_CONFIGS } from './base/calculation-configs';
import { CalculationConfig, CalculationType } from './base/calculation.types';

function createCalculationRoute(
  key: CalculationType,
  config: CalculationConfig,
): Route {
  return {
    path: config.routePath,
    loadComponent: () =>
      import(
        './components/smart/calculation-list-page/calculation-list-page.component'
      ).then((m) => m.CalculationListPageComponent),
    canActivate: [permissionGuard(config.permission)],
    data: { calculationType: key, config },
  };
}

export const calculationRoutes: Routes = (
  Object.keys(CALCULATION_CONFIGS) as CalculationType[]
).map((key) => createCalculationRoute(key, CALCULATION_CONFIGS[key]));
